"use strict";
var $ = require("../internals/export");
var call = require("../internals/function-call");
var toObject = require("../internals/to-object");
var isPrototypeOf = require("../internals/object-is-prototype-of");
var IteratorPrototype = require("../internals/iterators-core").IteratorPrototype;
var createIteratorProxy = require("../internals/iterator-create-proxy");
var getIteratorFlattenable = require("../internals/get-iterator-flattenable");
var IS_PURE = require("../internals/is-pure");
var FORCED = IS_PURE || function() {
  try {
    Iterator.from({ "return": null })["return"]();
  } catch (error) {
    return true;
  }
}();
var IteratorProxy = createIteratorProxy(function() {
  return call(this.next, this.iterator);
}, true);
$({ target: "Iterator", stat: true, forced: FORCED }, {
  from: function from(O) {
    var iteratorRecord = getIteratorFlattenable(typeof O == "string" ? toObject(O) : O, true);
    return isPrototypeOf(IteratorPrototype, iteratorRecord.iterator) ? iteratorRecord.iterator : new IteratorProxy(iteratorRecord);
  }
});
